import useTranslate from "hooks/useTranslate";
import { FortuneWheelSectionItem } from "components/pages/Profile/FortuneWheelPage/type/FortuneWheel";
import { useBreakpoint } from "hooks/useBreakpoint";
import { buildRoundedSectorPath, polarPoint } from "../../../../utils/geometry";
import "./styles.sass";

type SectorProps = {
  section: FortuneWheelSectionItem;
  outerRadius: number;
  startAngle: number;
  endAngle: number;
  cornerRadius: number;
  fill: string;
  textOffsetFromEdge?: number; // Отступ текста от внешней дуги внутрь (px)
};

const Sector = ({
  section,
  outerRadius,
  startAngle,
  endAngle,
  cornerRadius,
  fill,
  textOffsetFromEdge = 20,
}: SectorProps) => {
  const d = buildRoundedSectorPath(
    outerRadius,
    startAngle,
    endAngle,
    cornerRadius,
  );
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();

  // средний угол сектора
  const mid = (startAngle + endAngle) / 2;

  // выбираем моб/десктоп-размеры блока под текст
  const labelW = isDesktop ? 75 : 52;

  // верхняя кромка прямоугольника текста: на textOffsetFromEdge от внешней дуги
  const [topX, topY] = polarPoint(outerRadius - textOffsetFromEdge, 0);
  const foX = topX - labelW / 2;
  const foY = topY;

  return (
    <>
      <path d={d} fill={fill} />
      <g className="Sector" transform={`rotate(${mid})`}>
        <foreignObject
          x={foX}
          y={foY}
          width="100%"
          height="100%"
          pointerEvents="none"
        >
          <div className="Sector__label" style={{ width: labelW }}>
            {t(section.label)}
          </div>
        </foreignObject>
      </g>
    </>
  );
};

export default Sector;
